import { createAsyncThunk } from "@reduxjs/toolkit";
import { CUSTOMERS_URL, LIST_CUSTOMERS_SLICE } from "./customers.constant";
import { ErrorPopup } from "../../../utilities/swal";
import { axiosPrivate } from "../../../config/axios";

import { IErrorResponse } from "../../../utilities/error.config";
import { IAxiosErrorResponse } from "../../../interface/axiosError";

export const onAddCustomer = createAsyncThunk(
  `${LIST_CUSTOMERS_SLICE}/add-list`,
  async (data: FormData, thunkAPI: any) => {
    try {
      const res = await axiosPrivate.post(`${CUSTOMERS_URL}`, data);

      return res?.data;
    } catch (error: IAxiosErrorResponse | any) {
      ErrorPopup("Thao tác thất bại", error?.response?.data?.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const onGetListCustomer = createAsyncThunk(
  `${LIST_CUSTOMERS_SLICE}/get-list`,
  async (_, thunkAPI: any) => {
    try {
      const res = await axiosPrivate.get(`${CUSTOMERS_URL}`);

      return res?.data;
    } catch (error: IAxiosErrorResponse | any) {
      ErrorPopup("Thao tác thất bại", error?.response?.data?.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const onUpdateCustomer = createAsyncThunk(
  `${LIST_CUSTOMERS_SLICE}/update-list`,
  async (payload: { body: FormData; id: string }, thunkAPI: any) => {
    try {
      const res = await axiosPrivate.patch(
        `${CUSTOMERS_URL}/${payload?.id}`,
        payload?.body
      );

      return res?.data;
    } catch (error: IAxiosErrorResponse | any) {
      ErrorPopup("Thao tác thất bại", error?.response?.data?.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);
